var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 24h-4a.75.75 0 01-.75-.75V22h-3v1.25a.75.75 0 01-.75.75h-5.5a.75.75 0 01-.75-.75V22h-3v1.25a.75.75 0 01-.75.75h-4a.75.75 0 01-.75-.75V20h24v3.25a.75.75 0 01-.75.75zM16 0h-3v2a1 1 0 01-2 0V0H8a1 1 0 00-1 1v6a1 1 0 001 1h8a1 1 0 001-1V1a1 1 0 00-1-1zM10 10H7v2a1 1 0 01-2 0v-2H2a1 1 0 00-1 1v6a1 1 0 001 1h8a1 1 0 001-1v-6a1 1 0 00-1-1zM22 10h-3v2a1 1 0 01-2 0v-2h-3a1 1 0 00-1 1v6a1 1 0 001 1h8a1 1 0 001-1v-6a1 1 0 00-1-1z"
  })));
}

export default SvgPallet;